import {
  CountryData,
  ParsedCountry,
  parseCountry,
} from 'react-international-phone';

type CountryOptions = {
  preferred: ParsedCountry[];
  countries: ParsedCountry[];
};

export const resolveCountryOptions = (
  allCountries: CountryData[],
  preferredCountryCodes?: string[],
): CountryOptions => {
  return allCountries.reduce(
    (acc, countryData) => {
      const { preferred, countries } = acc;
      const country = parseCountry(countryData);

      const isPreferred =
        !!preferredCountryCodes && preferredCountryCodes.includes(country.iso2);
      if (isPreferred) {
        preferred.push(country);
      }

      countries.push(country);

      return {
        preferred,
        countries,
      };
    },
    {
      preferred: [],
      countries: [],
    } as CountryOptions,
  );
};

export const resolveInputPlaceholder = (country: ParsedCountry) => {
  const resolveDialCodeFormatString = () => {
    const { format } = country;

    const defaultPlaceholder = 'xxxxxxxxx';

    if (typeof format === 'string' && format.length > 0) {
      return format;
    }

    if (typeof format === 'object') {
      if (format.hasOwnProperty('default') && !!format.default) {
        return format.default;
      }
    }

    return defaultPlaceholder;
  };

  // Resolved country formats have "." as number placeholders, convert them to "x"
  return resolveDialCodeFormatString().replaceAll('.', 'x');
};
